import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { User } from '../types';
import { authAPI } from '../services/api';

interface AuthContextType {
  user: User | null; isLoading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void; isAdmin: boolean; isBrand: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const saved = localStorage.getItem('adroj_user');
    if (saved) setUser(JSON.parse(saved));
    setIsLoading(false);
  }, []);

  const login = async (email: string, password: string) => {
    const { user: u, token } = await authAPI.login(email, password);
    localStorage.setItem('adroj_token', token);
    localStorage.setItem('adroj_user', JSON.stringify(u));
    setUser(u as User);
  };

  const logout = () => {
    localStorage.removeItem('adroj_token');
    localStorage.removeItem('adroj_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, isAdmin: user?.role === 'admin', isBrand: user?.role === 'brand' }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
